import { FONT_FAMILIES, DISALLOWED_COLOR_VALUES, BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import tinycolor from 'tinycolor2';
export function getPaddingStyles(node) {
  let paddingStyle = '';
  if (node.attrs.paddingTop) {
    paddingStyle += `padding-top: ${node.attrs.paddingTop}; `;
  }
  if (node.attrs.paddingBottom) {
    paddingStyle += `padding-bottom: ${node.attrs.paddingBottom}; `;
  }
  if (node.attrs.paddingLeft) {
    paddingStyle += `padding-left: ${node.attrs.paddingLeft}; `;
  }
  if (node.attrs.paddingRight) {
    paddingStyle += `padding-right: ${node.attrs.paddingRight}; `;
  }
  return paddingStyle;
}
export function stylable(spec) {
  spec.attrs = Object.assign({}, spec.attrs, {
    fontFamily: {
      default: ''
    },
    fontColor: {
      default: ''
    },
    backgroundColor: {
      default: ''
    },
    paddingTop: {
      default: ''
    },
    paddingBottom: {
      default: ''
    },
    paddingLeft: {
      default: ''
    },
    paddingRight: {
      default: ''
    },
    borderRadius: {
      default: ''
    },
    borderColor: {
      default: ''
    },
    borderWidth: {
      default: ''
    },
    borderStyle: {
      default: ''
    }
  });
  spec.parseDOM?.forEach(function (rule) {
    let oldGetAttrs = rule.getAttrs;
    rule.getAttrs = dom => {
      let attrs = {};
      if (oldGetAttrs) {
        Object.assign(attrs, oldGetAttrs(dom));
      }
      let {
        fontFamily,
        color,
        borderRadius,
        paddingTop,
        paddingBottom,
        paddingLeft,
        paddingRight
      } = dom?.style;
      if (fontFamily && FONT_FAMILIES.includes(fontFamily)) {
        Object.assign(attrs, {
          fontFamily
        });
      }
      if (color && !DISALLOWED_COLOR_VALUES.includes(color) && tinycolor(color).isValid()) {
        let fontColor = tinycolor(color).toHexString();
        Object.assign(attrs, {
          fontColor
        });
      }
      if (paddingTop || paddingLeft || paddingRight || paddingBottom) {
        Object.assign(attrs, {
          paddingTop,
          paddingLeft,
          paddingRight,
          paddingBottom
        });
      }
      if (borderRadius) {
        Object.assign(attrs, {
          borderRadius
        });
      }
      if (dom.classList.contains(BLOCK_CLASSES.button) || dom.classList.contains('intercom-interblocks-button')) {
        let innerDomStyles = getInnerDomStyles(dom.firstChild);
        Object.assign(attrs, innerDomStyles);
      }
      return attrs;
    };
  });
  let oldToDOM = spec.toDOM;
  spec.toDOM = node => {
    if (!oldToDOM) {
      throw new Error('must specify a toDOM method');
    }
    let outputSpec = oldToDOM(node);
    if (outputSpec.length < 2) {
      throw new Error('must specify at least two elements in output spec');
    }
    // ensure we have a top level attrs hash not just a 'hole'
    if (outputSpec[1] === 0) {
      outputSpec.splice(1, 0, {});
    }
    let topLevelAttrs = outputSpec[1];
    let innerLevelAttrs = outputSpec[2] ? outputSpec[2][1] : {};
    if (!topLevelAttrs.style) {
      topLevelAttrs.style = '';
    }
    if (!innerLevelAttrs.style) {
      innerLevelAttrs.style = '';
    }
    if (node.attrs.fontFamily) {
      topLevelAttrs.style += `font-family: ${node.attrs.fontFamily}; `;
    }
    if (node.attrs.borderRadius) {
      innerLevelAttrs.style += `border-radius: ${node.attrs.borderRadius}; `;
    }
    if (node.attrs.fontColor) {
      topLevelAttrs.style += `color: ${node.attrs.fontColor}; `;
    }
    if (node.attrs.backgroundColor) {
      // There is additional button/section logic the spec needs to handle.
      // Button replies on buttonSpec to decide how the backgroundColor is applied depending on outline vs solid.
      // Container has a different structure and neither of the current style variables add the styles where required.
      if (node.attrs.responsive) {
        innerLevelAttrs.style += `background-color: ${node.attrs.backgroundColor}; `;
      } else if (!(node.type.name === 'button') && !node.attrs.container) {
        topLevelAttrs.style += `background-color: ${node.attrs.backgroundColor}; `;
      }
    }
    if (node.attrs.borderColor) {
      topLevelAttrs.style += `border-color: ${node.attrs.borderColor}; `;
    }
    if (hasPadding(node)) {
      if (node.attrs.container) {
        topLevelAttrs.style += getPaddingStyles(node);
      } else {
        innerLevelAttrs.style += getPaddingStyles(node);
        if (node.attrs.responsive) {
          innerLevelAttrs.style += 'border-collapse: separate; ';
        }
      }
    }

    // Unset styles if unused to prevent empty style attributes
    topLevelAttrs.style = topLevelAttrs.style.trim();
    innerLevelAttrs.style = innerLevelAttrs.style.trim();
    if (topLevelAttrs.style === '') {
      topLevelAttrs.style = null;
    }
    if (innerLevelAttrs.style === '') {
      innerLevelAttrs.style = null;
    }
    return outputSpec;
  };
  return spec;
}
function getInnerDomStyles(innerDom) {
  let {
    paddingTop,
    paddingRight,
    paddingLeft,
    paddingBottom,
    borderRadius,
    borderColor,
    borderWidth,
    borderStyle
  } = innerDom?.style;
  return {
    paddingTop,
    paddingRight,
    paddingLeft,
    paddingBottom,
    borderRadius,
    borderColor,
    borderWidth,
    borderStyle
  };
}
function hasPadding(node) {
  let {
    paddingTop,
    paddingRight,
    paddingLeft,
    paddingBottom
  } = node.attrs;
  return paddingTop || paddingRight || paddingLeft || paddingBottom;
}